import Vue from 'vue'
import VueRouter from 'vue-router'

import routes from './routes'
import jwt_decode from "jwt-decode";

import Notify from 'quasar/src/plugins/Notify.js';import Loading from 'quasar/src/plugins/Loading.js';
import store from 'base/BaseStore.js'

Vue.use(VueRouter)

const Router = new VueRouter({
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes,
  store,
  mode: 'history',
  base: '/'
})

Router.beforeEach(async (to, from, next) => {

  Loading.show()

  if (process.env.NODE_ENV !== 'production') console.log(" ROUTE TO ->", to);
  if (process.env.NODE_ENV !== 'production') console.log(" ROUTE NEEDS AUTH?", to.meta.requiresAuth);
  if (process.env.NODE_ENV !== 'production') console.log(" IS AUTHENTICATED ?", store.getters["auth/isAuthenticated"]);

  store.state.config.launch = {
    storage_key: process.env.VUE_APP_STORAGE_KEY,
    favicon_url: process.env.VUE_APP_FAVICON,
    tab_title: process.env.VUE_APP_TAB_TITLE,
    background_url: process.env.VUE_APP_LAUNCH_IMAGE_URL,
    background_color: process.env.VUE_APP_THEME_DARK_BACKGROUND,
    text_color: "#fafafa",
    logo_url: process.env.VUE_APP_HOST_LOGO,
    host_url: process.env.VUE_APP_HOST_URL,
    title: process.env.VUE_APP_APP_NAME,
    subtitle: process.env.VUE_APP_APP_TAGLINE,
    login_url: process.env.VUE_APP_LOGIN_IMAGE_URL,
  }

  // set IP address
  if (!store.state.config.ip_address && process.env.NODE_ENV === 'production') {
    await fetch('https://api.ipify.org?format=json')
      .then(x => x.json())
      .then(({ ip }) => { store.state.config.ip_address = ip; })
      .catch(() => {
        store.state.config.ip_address = '0.0.0.0'
        console.log("Error fetching IP Address.  Ad Block likely cause");
      });
    if (store.state.config.ip_address) console.log("Your IP Address is: ", store.state.config.ip_address);
  }

  // set keys 
  if (to.query.client_key) store.state.ids.client_key = to.query.client_key
  if (process.env.NODE_ENV !== 'production') console.log(" ROUTER store.client_key", store.state.ids.client_key);
  if (to.query.token) store.state.ids.client_key = to.query.token
  if (process.env.NODE_ENV !== 'production') console.log(" ROUTER store.token to client_key", store.state.ids.client_key);
  if (to.query.api_key) store.state.ids.api_key = to.query.api_key
  if (process.env.NODE_ENV !== 'production') console.log(" ROUTER store.api_key", store.state.ids.api_key);
  if (to.query.app) store.state.config.app = to.query.app
  if (process.env.NODE_ENV !== 'production') console.log(" ROUTER store.app", store.state.config.app); // the application to render

    // set config
    if (to.query.header === 'false') store.state.config.header = false // for views
    if (to.query.titlebar === 'false') store.state.config.titlebar = false // for components
    if (to.query.events === 'true') store.state.config.events = true // for parentWindow events (need to add event listener to parent)

  // check merchant authentication
  if (to.meta.requiresAuth && !store.getters["auth/isAuthenticated"]) {

    // redirect to login if no query params keys
    if (!store.state.ids.client_key || !store.state.ids.api_key || !store.state.config.app) {
      if (to.query.register_token) store.state.ids.register_token = to.query.register_token
      console.warn("Missing initialization 'client_key', 'api_key' and/or 'app' value");
      next({ name: 'AuthIndex' })
      return false
    }

    if (store.state.ids.client_key && store.state.ids.api_key) {
      store.state.auth.entityIdField = 'merchant_id'
      store.state.auth.responseEntityField = 'merchant'
      store.state.auth.userService = 'merchants'

      await store.dispatch('auth/authenticate', {
        api_key: store.state.ids.api_key,
        client_key: store.state.ids.client_key,
        server_key: process.env.VUE_APP_SERVER_KEY,
        strategy: 'appKey'
      })
        .then(res => {
          if (process.env.NODE_ENV !== 'production') console.log("CUSTOMER AUTH RESPONSE", res);
          const decoded = jwt_decode(res.accessToken)
          store.state.ids.tenant_id = decoded.tenant_id || res.merchant.tenant_id
          store.state.ids.developer_id = decoded.developer_id || res.merchant.developer_id
          store.state.ids.reseller_id = decoded.reseller_id || res.merchant.reseller_id
          store.state.ids.app_id = decoded.app_id || res.merchant.app_id
          store.state.ids.merchant_id = decoded.merchant_id || res.merchant.id
          store.state.ids.theme_id = decoded.theme_id || res.merchant.theme_id

          // CHECK FOR THEME
          if (!res.merchant.theme) {

            console.log("MISSING THEME!");
            next({ name: 'InitError', params: { 
            title: 'Initialization Error', 
            subtitle: 'Customer Application', 
            message: "Missing Theme"
          }})
        }

          next({ name: store.state.config.app })
          return false
        })
        .catch(err => {
          console.error("AUTHENTICATION ERROR", err);
          Loading.hide()
          Notify.create({
            message: 'Authentication Error',
            color: 'negative',
            position: 'top',
            caption: err.message,
            icon: "error",
            timeout: 5000,
            actions: [
              { label: 'CLOSE', color: 'white', handler: () => { /* ... */ } }
            ]
          })
          next({ name: 'AuthIndex', query: { app: store.state.config.app } })
          return false
        })
    }
  }
  else {
    next()
  }
})
export default Router
